import React from 'react';

import TabPanel from '@mui/lab/TabPanel';

import { Medical_HX_Update } from '../';

import {
  scrollTabPanelSx
} from './SoapLeftStyles';

const MedicalHxTabPanel = () => {
  return (
    <TabPanel
      value="2"
      sx={scrollTabPanelSx}>
      <Medical_HX_Update />
    </TabPanel>
  );
};

export default MedicalHxTabPanel;